function ConfAppBrokerDealer(props) {
  return (
    <div id="confidential-broker-dealer">
      <div className="row">
        <div className="col-lg-9 col-sm-12">
          <h3 id="conf_broker_text">Broker Dealer Information</h3>
        </div>
      </div>

      <div className="row" style={{ marginTop: "0px" }}>
        <div
          className="col-lg-3 col-md-3 col-sm-12"
          style={{ marginTop: "10px" }}
        >
          <strong id="conf_broker_q1_text">
            Are you registered with a Broker Dealer?*
          </strong>
        </div>
        <div
          id="registered"
          className="col-lg-3 col-md-3 col-sm-12 data"
          style={{ marginTop: "10px" }}
        >
          {props.broker_dealer_info.brokdealbool === true ? "Yes" : "No"}
        </div>
        {props.broker_dealer_info.brokdealbool === true && (
          <>
            <div
              className="col-lg-3 col-md-3 col-sm-12"
              style={{ marginTop: "10px" }}
            >
              <strong id="conf_broker_q2_text">
                Have you completed Anti-Money Laundering training through your
                Broker Dealer?*
              </strong>
            </div>
            <div
              id="completed"
              className="col-lg-3 col-md-3 col-sm-12 data"
              style={{ marginTop: "10px" }}
            >
              {props.broker_dealer_info.amltraining === false ? "No" : "Yes"}
            </div>
          </>
        )}
      </div>
      {props.broker_dealer_info.brokdealbool === true && (
        <>
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-12">
              <strong id="conf_broker_name_text">Broker Dealer Name*</strong>
            </div>
            <div
              id="conf_broker_name"
              className="col-lg-3 col-md-3 col-sm-12 data"
            >
              {props.broker_dealer_info.brokdealname}
            </div>
          </div>

          {props.broker_dealer_info.amltraining === true && (
            <>
              <div className="row">
                <div className="col-lg-3 col-md-3 col-sm-12">
                  <strong id="conf_trainingdate_text">
                    Anti-Money Laundering Training Completion Date*
                  </strong>
                </div>
                <div
                  id="conf_training_date"
                  className="col-lg-3 col-md-3 col-sm-12 data"
                >
                  {props.broker_dealer_info.amltrainingdate}
                </div>
              </div>
            </>
          )}
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-12">
              <strong id="conf_CRD_text">
                Personal Central Registration Depository Number (CRD)*
              </strong>
            </div>
            <div id="conf_CRD" className="col-lg-3 col-md-3 col-sm-12 data">
              {props.broker_dealer_info.crdnumber}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default ConfAppBrokerDealer;
